'use client'

import { useEffect } from 'react'

import { ProgressCircleIndeterminate } from '@/app/components/atoms/ProgressCircleIndeterminate'
import { cx, lockDocumentScroll } from '@/app/lib/utils'

import styles from './LoadingOverlay.module.scss'
import { SPINNER_SIZE } from './constants'
import type { LoadingOverlayProps } from './types'

/**
 * Overlay de carga a pantalla completa: fondo oscuro semitransparente con el
 * spinner del DS centrado.
 *
 * Es el indicador de carga **general** del sitio, extraído de
 * `NavigationProgress` al aparecer un segundo consumidor (la sección "Vistos
 * recientemente"), para no duplicar el overlay ni su z-index. Presentacional
 * puro: quién lo muestra y cuándo lo decide el consumidor, así que no lleva test
 * propio (Constitución, Principio IX).
 *
 * Bloquea el scroll de la página mientras está montado (mismo patrón que el
 * menú de `Header.tsx`): al ser un overlay a pantalla completa, dejar
 * scrollear el contenido de debajo no tiene sentido — el visitante no ve
 * nada nuevo y solo consigue "perder" la posición de scroll bajo el propio
 * spinner. El bloqueo es compartido (`lockDocumentScroll`): convive con el
 * del buscador o el menú, que pueden seguir activos al empezar la navegación.
 */
export function LoadingOverlay({ label, className }: LoadingOverlayProps) {
  useEffect(() => lockDocumentScroll(), [])

  return (
    <div className={cx(styles.overlay, className)}>
      <ProgressCircleIndeterminate size={SPINNER_SIZE} label={label} />
    </div>
  )
}
